import type { AImageProps } from '../../atoms/AImage/AImage.types';
import type { AVideoProps } from '../../atoms/AVideo/AVideo.types';
import type { MButtonOverlayProps } from '../MButtonOverlay/MButtonOverlay.types';

export enum MVideoThumbnailAriaLabel {
  DefaultPlay = 'Play video',
}

export enum MVideoThumbnailErrorMessage {
  ThumbnailFailed = 'The thumbnail could not be retrieved',
  VideoFailed = 'Unable to load video',
}

export interface MVideoThumbnailProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  aImage?: AImageProps;
  aVideo?: AVideoProps;
  /** Play button overlay rendered centered over the thumbnail. Defaults to a play icon button if not provided. */
  mButtonOverlay?: MButtonOverlayProps;
}
